import { TextCell } from '@common/components/TextCell';

interface LastUpdatedCellProps {
	lastUpdated: string;
}

export const LastUpdatedCell = ({ lastUpdated }: LastUpdatedCellProps) => {
	return <TextCell value={lastUpdated} />;
};
